/**
 * Savanna Sips – Design System
 * 
 * Color Philosophy updated from Logo:
 * Warm sunset hues, deeply rooted earth tones, and vibrant sun orange.
 */

export const colors = {
  // ── Logo Derived Scale ─────────────────────────────────────────
  cream:       '#E4D4C3',  // Logo background hue
  offWhite:    '#F4EAE0',  // Lightened version for main background
  latte:       '#D8B79B',  // Warm mid-tone
  caramel:     '#D96D29',  // Sun orange highlight
  mahogany:    '#A63C1E',  // Deep sunset red
  espresso:    '#2B1509',  // Logo tree/text color
  charcoal:    '#1F110B',  // Near black text color
  
  fog:         '#E8DCCA',  // Subtle dividers
  mist:        '#C2A590',  // Muted secondary text
  sand:        '#C7AE97',  // Burlap sack 
  terra:       '#8B4224',  // Terracotta / earthy

  white:       '#FFFFFF',
  transparent: 'transparent',
};

export const typography = {
  // Import these fonts in index.css via Google Fonts
  primary:   "'Cormorant Garamond', Georgia, serif", 
  secondary: "'Inter', system-ui, sans-serif",        
  mono:      "'JetBrains Mono', monospace",           

  weightLight:    300,
  weightRegular:  400,
  weightMedium:   500,
  weightSemiBold: 600,
  weightBold:     700,
};

export const spacing = {
  xs:   '0.5rem',
  sm:   '1rem',
  md:   '1.5rem',
  lg:   '2.5rem',
  xl:   '4rem',
  xxl:  '7rem',
  page: '6%',
};

export const transitions = {
  fast:   'all 0.25s ease',
  base:   'all 0.4s ease',
  slow:   'all 0.9s ease',         
};

/**
 * ASSET LINKS
 */
export const assets = {
  logo:           '/logo.png',
  heroBg:         'https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?w=1800&q=85',
  parallaxBeans:  'https://images.unsplash.com/photo-1447933601403-0c6688de566e?w=1800&q=85',
  galleryImg1:    '/dry-beans.png',
  galleryImg2:    '/grinded.png',
  galleryImg3:    '/beanspackage.png',
  galleryImg4:    '/package.png',
  featureLeft:    '/dry-beans.png',
  featureRight:   '/grinded.png',
  // AI-Generated imagery for new pages
  imgProducts:    '/img-products.png',
  imgFarm:        '/img-farm.png',
  imgProcess:     '/img-process.png',
  imgVision:      '/img-vision.png',
  imgBrew:        '/img-brew.png',
  // Unsplash supplemental images
  roastingImg:    'https://images.unsplash.com/photo-1611854779393-1b2da9d400fe?w=900&q=85',
  beansCloseup:   'https://images.unsplash.com/photo-1559056199-641a0ac8b55e?w=900&q=85',
  cherriesImg:    'https://images.unsplash.com/photo-1611021061285-f93fa6c41183?w=900&q=85',
};
